function openCartDrawer() {
  setTimeout(function() {
    console.log($('.drawer.cart__drawer').hasClass('drawer--visible'));
  if (!$('.drawer.cart__drawer').hasClass('drawer--visible')) {
    $('[data-drawer-toggle="drawer-cart"]').trigger('click'); 
  }
  }, 1500)
}

// free gift
function FreeProductAdd(){
  var id = $('input[type="hidden"].bombo-free-product').val()
   $.ajax({
    type: 'POST',
    context: this,
    url: '/cart/add.js',
    data: { quantity: 1, id: id } ,
    dataType: 'json',
    success: function() {
      // document.dispatchEvent(new CustomEvent('theme:cart:reload'));
      // document.dispatchEvent(new CustomEvent('theme:cart:init'));
      
    }
  });
}
function FreeProductRemove(){
  var id = $('input[type="hidden"].bombo-free-product').val();
   $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { quantity: 0, id: id },
    dataType: 'json',
    success: function() {
      console.log('product remove')
      // document.dispatchEvent(new CustomEvent('theme:cart:reload'));
      // document.dispatchEvent(new CustomEvent('theme:cart:init'));
    }
  });
}


function priceOver() {
  $.getJSON("/cart", function(cart) {
    let total_price = cart.total_price;
    console.log(total_price,'total price');
    let offerPriceval = $('input[type="hidden"].bombo-free-product').data('offer-price') * 100;
    let offerPrice = Math.round(parseInt(offerPriceval, 10) * (Shopify.currency.rate || 1));
    let freeProductId = $('input[type="hidden"].bombo-free-product').val();
    let isFreeProductInCart = false;
    cart.items.forEach(function(item) {
      // console.log(item.final_price,'final price');
      if (item.id == freeProductId && item.final_price == 0) {
        isFreeProductInCart = true;
       }
    });
     let sessionKey = window.sessionStorage.getItem('freeItemDelete');
    if (total_price >= offerPrice && !isFreeProductInCart && !sessionKey) {
      FreeProductAdd();
    }
    window.sessionStorage.removeItem('freeItemDelete');
  });
}


// window.upcartOnItemRemoved = (_, item) => { 
//   console.log('remove',item);
//   let freeProductId = $('input[type="hidden"].bombo-free-product').val();
//   if (item.id == freeProductId && item.final_price == 0) {
//     window.sessionStorage.setItem('freeItemDelete', 'true');
//   }
// }

$(document).ready(function() {
  window.upcartOnItemRemoved = (_, item) => { 
    console.log('remove',item);
    let freeProductId = $('input[type="hidden"].bombo-free-product').val();
    if (item.id == freeProductId && item.final_price == 0) {
      window.sessionStorage.setItem('freeItemDelete', 'true');
    }
  }
  window.upcartOnCartUpdated=(cart)=>{
    console.log('cart-update function hit');
    priceOver();
  }
})
window.upcartOnCartUpdated=(cart)=>{
  console.log('cart update',cart);
  priceOver();
}

// endFreegift

function CheckSampleProduct(){
  // console.log('CheckSampleProduct');
      setTimeout(function(){
        var FreeProduct = false
        var PatchBundle = false
        $.getJSON("/cart", function(cart){
          cart.items.forEach(function(item) {
            console.log('Handle',item.handle)
            if(item.handle == 'clear-skin-kit'){
              PatchBundle = true
            }
            if(item.handle == 'reusable-cotton-pads'){
              FreeProduct = true
            }
             if(item.handle == 'hydrocolloid-nose-patches' || item.handle == 'clearing-spot-patches'){
                $('.drawer-upsell.for-patches-drawer').removeClass('hide');
                $('.drawer-upsell.non-patches-drawer').addClass('hide')
              }else{
               $('.drawer-upsell.for-patches-drawer').addClass('hide');
               $('.drawer-upsell.non-patches-drawer').removeClass('hide')
              }
          })

         var CartCount =  cart.item_count;
         if(PatchBundle && !FreeProduct){
               FreeProductAdd();
         } 
         // if(CartCount >= 3 && !FreeProduct && !PatchBundle){
         //       FreeProductAdd();
         //  } 

         if(FreeProduct && !PatchBundle){
           var id = $('input[type="hidden"].bombo-free-product').val()
               $.ajax({
                type: 'POST',
                context: this,
                url: '/cart/change.js',
                data: { quantity: 0, id: id } ,
                dataType: 'json',
                success: function() {
                  document.dispatchEvent(new CustomEvent('theme:cart:reload'));
                  document.dispatchEvent(new CustomEvent('theme:cart:init'));
                }
              });
          } 
        }) 
     }, 1200);
}

// priceOver();
// document.addEventListener('theme:cart:added', function(e) {
//   // console.log('theme:cart:added', e);
//   // CheckSampleProduct();
//   // priceOver();
//   //openCartDrawer()
// })






$(document).ready(function(){
  $('.sticky_cart.mbl_cart .stcky-atc').click(function(){
      $('.product__details_desktop .btn--add-to-cart[data-add-to-cart]').trigger('click'); 
  });
  
// $('.btn--add-to-cart[data-add-to-cart]').click(function(){ 
//       document.dispatchEvent(new CustomEvent('theme:cart:init'));
//       setTimeout(function(){
//         $('[data-drawer-toggle="drawer-cart"]').trigger('click'); 
//        }, 1500);
//      CheckSampleProduct();
//   });

  function AddToCart(id){
    // console.log('add to cart func: '+id);
        $.ajax({
        type: 'POST',
        context: this,
        url: '/cart/add.js',
        data: { quantity: 1, id: id },
        dataType: 'json',
        success: function() {
           document.dispatchEvent(new CustomEvent('theme:cart:init'));
           openCartDrawer();
           // CheckSampleProduct();
        }
      });
  }

  $(document).on("click",".product-bundle-select-btn",function(e){    
      e.preventDefault();
      var id = $(this).attr('data-id');
      AddToCart(id) 
      // CheckSampleProduct();
  })  
   $(document).on("click",".upsell-collection .upsell--add-to-cart",function(e) {    
      e.preventDefault();
      var id = $(this).parents('.upsell-item').find('form input[type="hidden"][name="id"]').val();
      AddToCart(id)
      // CheckSampleProduct();
  })

$(document).on("click",".drawer-upsell-item-add",function(e){    
    e.preventDefault();
    var id = $(this).attr('data-id');
    $.ajax({
      type: 'POST',
      context: this,
      url: '/cart/add.js',
      data: { quantity: 1, id: id } ,
      dataType: 'json',
      success: function() {
        document.dispatchEvent(new CustomEvent('theme:cart:reload'));
        document.dispatchEvent(new CustomEvent('theme:cart:init'));
        // CheckSampleProduct();
      }
    });
})  

// $(document).on("click",".cart__items__remove, .drawer__content .quantity__button",function(e){ 
//     // CheckSampleProduct()
// })    
  

  $('.pro-image-compare .icm_grid').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   draggable:false, 
   accesibility: false,
   swipe: false,
   touchMove: false,
   arrows: false,
   dots:false
 });

$('.real_results_images').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   dots:false
 });  



  $('.panel-faq-section').hide();
  $('.accordion-faq-section').click(function() {
    $(this).toggleClass("active");
     $(this).parent('.faq-text').toggleClass("active");
    $(this).next('.panel-faq-section').slideToggle();  
  });        
 

$(document).on("click",".accordion__title.real-result-title",function(){ 
   $('.real_results_images').slick('refresh');
})  

// $(document).on("click",".product-accordion .accordion__title:not(.real-result-title)",function(){   
//       $('.accordion__title.real-result-title').removeClass('accordion-is-open');
// })  
  
$('.free-sample span.iconn').click(function(){
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
      $(this).parents('.drawer-upsell-wrap').find('.free-sample-products').show();
  }else{
      $(this).parents('.drawer-upsell-wrap').find('.free-sample-products').hide();
  }
})  
  
});

// =======

$(document).ready(function() {
  
  // If the comparison slider is present on the page lets initialise it, this is good you will include this in the main js to prevent the code from running when not needed
  if ($(".comparison-slider")[0]) {
    let compSlider = $(".comparison-slider");
  
    //let's loop through the sliders and initialise each of them
    compSlider.each(function() {
      let compSliderWidth = $(this).width() + "px";
      $(this).find(".resize img").css({ width: compSliderWidth });
      drags($(this).find(".divider"), $(this).find(".resize"), $(this));
    });

    //if the user resizes the windows lets update our variables and resize our images
    $(window).on("resize", function() {
      let compSliderWidth = compSlider.width() + "px";
      compSlider.find(".resize img").css({ width: compSliderWidth });
    });
  }
  
}); 

// This is where all the magic happens
// This is a modified version of the pen from Ege Görgülü - https://codepen.io/bamf/pen/jEpxOX - and you should check it out too.
function drags(dragElement, resizeElement, container) {
  
  // This creates a variable that detects if the user is using touch input insted of the mouse.
  let touched = false;
  window.addEventListener('touchstart', function() {
    touched = true;
  });
  window.addEventListener('touchend', function() {
    touched = false;
  });
  
  // clicp the image and move the slider on interaction with the mouse or the touch input
  dragElement.on("mousedown touchstart", function(e) {
      
      //add classes to the emelents - good for css animations if you need it to
      dragElement.addClass("draggable");
      resizeElement.addClass("resizable");
      //create vars
      let startX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;
      let dragWidth = dragElement.outerWidth();
      let posX = dragElement.offset().left + dragWidth - startX;
      let containerOffset = container.offset().left;
      let containerWidth = container.outerWidth();
      let minLeft = containerOffset + 10;
      let maxLeft = containerOffset + containerWidth - dragWidth - 10;
      
      //add event listner on the divider emelent
      dragElement.parents().on("mousemove touchmove", function(e) {
        
        // if the user is not using touch input let do preventDefault to prevent the user from slecting the images as he moves the silder arround.
        if ( touched === false ) {
          e.preventDefault();
        }
        
        let moveX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;
        let leftValue = moveX + posX - dragWidth;

        // stop the divider from going over the limits of the container
        if (leftValue < minLeft) {
          leftValue = minLeft;
        } else if (leftValue > maxLeft) {
          leftValue = maxLeft;
        }

        let widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + "%";

        $(".divider").css("left", widthValue).on("mouseup touchend touchcancel", function() {
          $(this).removeClass("draggable");
          resizeElement.removeClass("resizable");
        });
        
        $(".resizable").css("width", widthValue);
        
      }).on("mouseup touchend touchcancel", function() {
        dragElement.removeClass("draggable");
        resizeElement.removeClass("resizable");
        
      });
    
    }).on("mouseup touchend touchcancel", function(e) {
      // stop clicping the image and move the slider
      dragElement.removeClass("draggable");
      resizeElement.removeClass("resizable");
    
    });
  
} 


$(document).ready(function() {
  $('.notify-me').click(function(){
     $('.notify-me-wrapper').show();
   });
  
  $(document).on("click",".accordion__body_img",function(){ 
      $('.accordion__body_img_modal').remove();
      var accordion__body_img = $(this).attr('src');
      $('body').append('<div class="accordion__body_img_modal"><div class="accordion__body_img_modal_inner"><button type="button" class="close-modal-btn"><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 -0.5 25 25" fill="none"><path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="#000000"/></svg></button><img src="'+accordion__body_img+'"></div></div>');
  })   
  
  $(document).on("click",".close-modal-btn",function(){ 
      $('.accordion__body_img_modal').remove();
  });
  
  $('.scrolling-tab-section .wrap').slick({
    dots: false,
    infinite: false, 
    arrow: true, 
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        } 
      }                                                                                     
    ] 
  }); 
// product-page save 
   // let initialValue = $('.quantity__input').val('3');
    $('.custom__quantity__button').click(function(){
       let regularPrice = $(this).data('regular-price');
       let compairPrice = $(this).data('compair-price');
       $('.product__price--sale').text(regularPrice);
       $('.compare-price').find('s').text(compairPrice);
       $('.custom__quantity__button').removeClass('active');
       $(this).addClass('active');
       let price = $(this).data('price');
       $('.price-content').hide();
       $(this).next('.price-content').text(price);
       $(this).next('.price-content').show();
       let buttonVal = $(this).text();
       $('.quanity-text').text(buttonVal);
       let input_value =  $('.quantity__input').val(buttonVal);
    });

    // claim-form
    $(".custom_claim_form .popup-content .close, .custom_claim_form .popup-overlay").on("click", function(){
      $(".popup-overlay").addClass("claim-submit-information");
      $(".popup-overlay").removeClass("claim-succesffull");
      console.log('redirect-to-home');
      window.location.href = "/";
   }); 
  
});